import Component from "../core/Component"
import { EVENTS } from "../core/Events"
import EventBus from "../core/EventBus"
import debounce from "lodash/debounce"
import { najaAjax } from "../utils/ajax"

const STATES = {
    ACTIVE: "is-active",
    LOADING: "is-loading",
    TIP_VISIBLE: "is-tip-visible",
    SEARCH_COMPLETE: "is-search-complete",
}

export default class Search extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            input: null,
            inner: null,
            close: null,
        }

        this.request = null
    }

    prepare() {
        EventBus.on(EVENTS.SEARCH_TOGGLE, this.handleSearchToggle)
        this.element.addEventListener("click", this.handleClick)
        this.ref.close.addEventListener("click", this.handleCloseClick)
        this.ref.input.addEventListener("input", this.handleInputInput)
    }

    destroy() {
        EventBus.off(EVENTS.SEARCH_TOGGLE, this.handleSearchToggle)
    }

    handleSearchToggle = () => {
        this.toggle()
    }

    handleCloseClick = (event) => {
        event.preventDefault()
        this.close()
    }

    handleClick = (event) => {
        if (!this.ref.inner.contains(event.target)) {
            event.preventDefault()
            this.close()
        }
    }

    handleInputInput = (event) => {
        const value = this.ref.input.value
        this.element.classList.remove(STATES.SEARCH_COMPLETE)
        this.debounceShowTip.cancel()

        if (value.length === 0) {
            this.hideTip()
            return
        } else if (value.length < 3) {
            this.debounceShowTip()
        } else {
            this.hideTip()
            this.element.classList.add(STATES.LOADING)
            this.debounceSearch()
        }
    }

    toggle() {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.element.classList.add(STATES.ACTIVE)
        this.ref.input.focus()
        EventBus.emit(EVENTS.SEARCH_OPENED)
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }
        this.element.classList.remove(STATES.ACTIVE)
        EventBus.emit(EVENTS.SEARCH_CLOSED)
    }

    search() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }

        if (this.request) {
            this.request.abort()
        }

        this.element.classList.add(STATES.LOADING)
        const url = `${this.options.url}`.replace("__QUERY__", this.ref.input.value)
        this.request = najaAjax({
            url,
            method: 'POST',
            success: () => {
                this.element.classList.add(STATES.SEARCH_COMPLETE)
            },
            complete: () => {
                this.element.classList.remove(STATES.LOADING)
            },
            // najaOptions: { history: false }
        })

    }

    debounceSearch = debounce(this.search, 500)

    hideTip() {
        this.element.classList.remove(STATES.TIP_VISIBLE)
    }

    showTip() {
        this.element.classList.add(STATES.TIP_VISIBLE)
    }

    debounceShowTip = debounce(this.showTip, 1500)
}
